import React from 'react';
import { Appearance } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { InjectedProps } from '../Stripe/withStripe';
import CheckoutForm from './CheckoutForm';
import { useStripeCheckoutSubmission } from './hooks/useStripeCheckout';
import { Loader } from 'components/common/Loader';

import style from './StripeCheckout.scss';

type StripeCheckoutNewFlowOwnProps = {
  closingBalance: number;
  isCc?: boolean;
};

type StripeCheckoutNewFlowProps = StripeCheckoutNewFlowOwnProps & InjectedProps;

export const StripeCheckoutNewFlow = ({
  closingBalance,
  isCc = false,
  stripe,
}: StripeCheckoutNewFlowProps) => {
  const { clientSecret, supplierPaymentId, isLoading, error } = useStripeCheckoutSubmission({
    closingBalance,
    isCc,
  });

  React.useEffect(() => {
    if (error) {
      Wahanda.ToastNotifications.sendMessage(error, { variant: 'danger' });
    }
  }, [error]);

  const appearance: Appearance = {
    theme: 'stripe',
  };

  const loader = 'auto';

  return (
    <>
      {isLoading ? (
        <div className={style.root}>
          <Loader positionAbsolute />
        </div>
      ) : clientSecret ? (
        <div className={style.root}>
          <Elements options={{ clientSecret, appearance, loader }} stripe={stripe}>
            <CheckoutForm supplierPaymentId={supplierPaymentId} />
          </Elements>
        </div>
      ) : null}
    </>
  );
};
